import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { useMedereSiteService } from "../../../../servicesHooks/MedereSite/useMedereSiteService";

export default function ConsentTab() {
    const { getSiteConsent } = useMedereSiteService();
    
    const [consentHTML, setConsentHTML] = useState<string | null>(null);

    useEffect(() => {   
        getSiteConsent().then((consent) => setConsentHTML(DOMPurify.sanitize(consent)));
    }, []);

    return <div className="consent-content" dangerouslySetInnerHTML={{ __html: consentHTML }} />;
}
